// Built from the same Kubernetes ConfigMap value used by the API.
const configured = process.env.REACT_APP_DATA_WORKSPACE_ENABLED;
export const DATA_WORKSPACE_ENABLED = configured == null || configured === ""
  ? process.env.NODE_ENV !== "production"
  : configured === "true";

export const WORKSPACE_SELECTION_FIELDS = new Set([
  "dataset_selection", "dataset_version_id", "datasetVersionId", "version_id", "versionId",
  "expected_revision", "expectedRevision", "analysis_execution", "execution_ref",
]);
// Only used at the analysis API boundary. Ordinary filters and source IDs are preserved.
export function legacyAnalysisPayload(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return value;
  const result = { ...value };
  const source = result.dataset_selection?.source;
  if (source && !result.fileId && !result.file_id && !result.importJobId && !result.import_job_id) {
    if (source.kind === "file") result.fileId = source.id;
    else if (source.kind === "import_job") result.importJobId = source.id;
  }
  for (const key of WORKSPACE_SELECTION_FIELDS) delete result[key];
  if (["raw", "working", "saved"].includes(result.mode)) delete result.mode;
  for (const key of ["patient_filter", "fileCopy"]) {
    if (result[key]) result[key] = legacyAnalysisPayload(result[key]);
  }
  return result;
}
